module.exports = __webpack_public_path__ + "media/images/workplace/job_type_bg/job_type_background_text_creation-14e90f82be576506df3cc3f8564a6696.svg";